/**
 * Developer console module
 * @description Unlike window.console no need to be removed before production.
 * @author Oleg Vaka
 */
const CONSOLE = window.console;
const TYPES = {
  log: 'log',
  warning: 'warn',
  error: 'error',
};

let isEnabled;
let logEvents = [];

init();

/**
 * @function init
 * @description init log module.
 * Put log functions into global schneider namespace.
 * Set if info can be logged immediately or should collect.
 */
function init() {
  isEnabled = process.env.NODE_ENV !== 'production';
  window.schneider = window.schneider || {};
  window.schneider.console = {
    enable,
    disable,

    showLogBuffer,

    log: info,
    warn,
    error,
  };
}

/**
 * @function disable
 * @description Not show console info.
 */
function disable() {
  isEnabled = false;
}

/**
 * @function enable
 * @description Show all collected info if was disabled.
 * Set show info immediately.
 * Clear log buffer.
 */
function enable() {
  if (!isEnabled) {
    isEnabled = true;
    showLogBuffer(true);
    logEvents = [];
  }
}

/**
 * @function showLogBuffer
 * @description show collected log info.
 */
function showLogBuffer(skipNoResultInfo) {
  if (logEvents.length) {
    logEvents.forEach((logEvent) => logEvent.show());
  } else if (!skipNoResultInfo) {
    CONSOLE.log('No log events.');
  }
}

/**
 * @function info
 * @param {*} logObject
 * @description Show console info message or add info object into buffer if module disabled.
 */
function info(logObject) {
  if (isEnabled) {
    CONSOLE.log(logObject);
  } else {
    logEvents.push(new LogEvent(TYPES.log, logObject));
  }
}

/**
 * @function warn
 * @param {*} logObject
 * @description Show console warning message or add info object into buffer if module disabled.
 */
function warn(logObject) {
  if (isEnabled) {
    CONSOLE.warn(logObject);
  } else {
    logEvents.push(new LogEvent(TYPES.warning, logObject));
  }
}

/**
 * @function error
 * @param {*} logObject
 * @description Show console error message or add info object into buffer if module disabled.
 */
function error(logObject) {
  if (isEnabled) {
    CONSOLE.error(logObject);
  } else {
    logEvents.push(new LogEvent(TYPES.error, logObject));
  }
}

/**
 * @class LogEvent
 * @field {string} type - log type (log, warn, error)
 * @field {*} logObject - object to be collected as log data
 * @field {Date} time - date time of creating.
 * @description helper class to collection log data
 */
class LogEvent {
  /**
   * @constructor
   * @param type
   * @param logObject
   * @description Creates new log event object with specified type and logObject.
   * Time sets on the create.
   */
  constructor(type, logObject) {
    this.type = type;
    this.logObject = logObject;
    this.time = new Date();
  }

  /**
   * @function show
   * @description render current log event object according specified type.
   */
  show() {
    CONSOLE.log('Original event time: ' + this.time);
    switch (this.type) {
      case TYPES.log:
        CONSOLE.log(this.logObject);
        break;
      case TYPES.warn:
        CONSOLE.warn(this.logObject);
        break;
      case TYPES.error:
        CONSOLE.error(this.logObject);
        break;
      default:
        CONSOLE.warn('Unknown logging type. Will be logged as simple log.');
        CONSOLE.log(this.logObject);
    }
  }
}

const log = {
  enable,
  disable,

  showLogBuffer,

  info,
  warn,
  error,
};

export { log };
